<div class="modal-header blue">
  <h4 class="modal-title">Create New Provider</h4>

  <button></button>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<div class="modal-body">
  <div class="row sm-gaps">
    <div class="col">
      <div class="input-label">NPI</div>
      <input type="text" placeholder="Provider Id" class="input" />

      <div class="input-label">First name</div>
      <input type="text" placeholder="Enter First Name" class="input" />
      <div class="input-label">last name</div>
      <input type="text" placeholder="Enter Last Name" class="input" />
      <div class="input-label">mi</div>
      <input type="text" placeholder="Enter MI" class="input" />
      <div class="input-label">degree</div>
      <input type="text" placeholder="Enter Degree" class="input" />
      <ddl-practice formControlName="pms"></ddl-practice>
    </div>

    <!-- <div class="col">
        <div class="input-label">
          provider group id
        </div>
        <input type="text" placeholder="Provider Group Id" class="input" >
      </div> -->

    <div class="col-4">
      <div class="input-label">Contact</div>
      <input type="text" placeholder="Enter Contact" class="input" />
    </div>

    <div class="col-4 d-flex pl-3 pt-3">
      <label class="checkbox mt-1">
        <input type="checkbox" />
        <span>ECS</span>
      </label>

      <div class="input-wrap datepicker w-154px ml-auto">
        <input
          class="input"
          placeholder="yyyy-mm-dd"
          name="dp"
          ngbDatepicker
          [placement]="'bottom-right'"
          #d="ngbDatepicker"
        />

        <button type="button" class="datepicker-button" (click)="d.toggle()">
          <i class="fas fa-calendar-alt"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="row sm-gaps">
    <div class="col"></div>

    <div class="col"></div>

    <div class="col-4">
      <div class="input-label">title</div>
      <input type="text" placeholder="Enter Title" class="input" />
    </div>

    <div class="col-4 d-flex pl-3 pt-3">
      <label class="checkbox mt-1">
        <input type="checkbox" />
        <span>ERA</span>
      </label>

      <div class="input-wrap datepicker w-154px ml-auto">
        <input
          class="input"
          placeholder="yyyy-mm-dd"
          name="dt"
          ngbDatepicker
          [placement]="'bottom-right'"
          #dd="ngbDatepicker"
        />

        <button type="button" class="datepicker-button" (click)="dd.toggle()">
          <i class="fas fa-calendar-alt"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="row sm-gaps">
    <div class="col"></div>

    <div class="col"></div>

    <div class="col-4">
      <div class="input-label">Phone</div>
      <input type="text" placeholder="Enter Phone" class="input" />
    </div>

    <div class="col-4 d-flex pl-3 pt-3">
      <label class="checkbox mt-1">
        <input type="checkbox" />
        <span>Claim Status</span>
      </label>

      <div class="input-wrap datepicker w-154px ml-auto">
        <input
          class="input"
          placeholder="yyyy-mm-dd"
          name="dt"
          ngbDatepicker
          [placement]="'bottom-right'"
          #dd="ngbDatepicker"
        />

        <button type="button" class="datepicker-button" (click)="dd.toggle()">
          <i class="fas fa-calendar-alt"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="row sm-gaps">
    <div class="col-4">
      <div class="input-label">Address 1</div>
      <input type="text" placeholder="Enter Address 1" class="input" />
    </div>

    <div class="col-4">
      <div class="input-label">Fax</div>
      <input type="text" placeholder="Enter Fax" class="input" />
    </div>

    <div class="col-4 d-flex pl-3 pt-3">
      <label class="checkbox mt-1">
        <input type="checkbox" />
        <span>Eligibility</span>
      </label>

      <div class="input-wrap datepicker w-154px ml-auto">
        <input
          class="input"
          placeholder="yyyy-mm-dd"
          name="dt"
          ngbDatepicker
          [placement]="'bottom-right'"
          #dd="ngbDatepicker"
        />

        <button type="button" class="datepicker-button" (click)="dd.toggle()">
          <i class="fas fa-calendar-alt"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="row sm-gaps">
    <div class="col-4">
      <div class="input-label">address 2</div>
      <input type="text" placeholder="Enter Address 2" class="input" />
    </div>

    <div class="col-4">
      <div class="input-label">email</div>
      <input type="text" placeholder="Enter Email" class="input" />
    </div>

    <div class="col-4 d-flex pl-3 pt-3">
      <label class="checkbox mt-1">
        <input type="checkbox" />
        <span>Statements</span>
      </label>

      <div class="input-wrap datepicker w-154px ml-auto">
        <input
          class="input"
          placeholder="yyyy-mm-dd"
          name="dt"
          ngbDatepicker
          [placement]="'bottom-right'"
          #dd="ngbDatepicker"
        />

        <button type="button" class="datepicker-button" (click)="dd.toggle()">
          <i class="fas fa-calendar-alt"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="row sm-gaps">
    <div class="col-4">
      <div class="input-label">City</div>
      <input type="text" placeholder="Enter City" class="input" />
    </div>

    <div class="col-4">
      <div class="input-label">fee schedule</div>

      <div class="input-wrap select">
        <select class="input">
          <option>Select State</option>
        </select>
      </div>
    </div>

    <div class="col-4 d-flex pl-3">
      <div class="pr-2">
        <div class="input-label">date setup</div>
        <div class="input-wrap datepicker">
          <input
            class="input"
            placeholder="yyyy-mm-dd"
            name="dt"
            ngbDatepicker
            [placement]="'bottom-right'"
            #dd="ngbDatepicker"
          />

          <button type="button" class="datepicker-button" (click)="dd.toggle()">
            <i class="fas fa-calendar-alt"></i>
          </button>
        </div>
      </div>

      <div class="pl-2">
        <div class="input-label">Date terminate</div>

        <div class="input-wrap datepicker">
          <input
            class="input"
            placeholder="yyyy-mm-dd"
            name="dt"
            ngbDatepicker
            [placement]="'bottom-right'"
            #dd="ngbDatepicker"
          />

          <button type="button" class="datepicker-button" (click)="dd.toggle()">
            <i class="fas fa-calendar-alt"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row sm-gaps">
    <div class="col-4 d-flex">
      <div class="w-100 pr-2">
        <div class="input-label">state</div>

        <div class="input-wrap select">
          <select class="input">
            <option>Select State</option>
          </select>
        </div>
      </div>

      <div class="w-100 pl-2">
        <div class="input-label">Zip</div>
        <input type="text" placeholder="Enter ZIP" class="input" />
      </div>
    </div>

    <div class="col-4">
      <div class="input-label">certification status</div>
      <div class="d-flex">
        <label class="input-wrap radio mr-3">
          <input type="radio" name="wew" />
          <span class="text">Production</span>
        </label>
        <label class="input-wrap radio">
          <input type="radio" name="ewew" />
          <span class="text">Test</span>
        </label>
      </div>
    </div>

    <div class="col-4 d-flex pl-3">
      <div class="pr-2">
        <div class="input-label">Last db update</div>

        <div class="input-wrap datepicker">
          <input
            class="input"
            placeholder="yyyy-mm-dd"
            name="dt"
            ngbDatepicker
            [placement]="'bottom-right'"
            #dd="ngbDatepicker"
          />

          <button type="button" class="datepicker-button" (click)="dd.toggle()">
            <i class="fas fa-calendar-alt"></i>
          </button>
        </div>
      </div>

      <div class="pl-2">
        <div class="input-label">updated by</div>

        <div class="input-wrap datepicker">
          <input
            class="input"
            placeholder="yyyy-mm-dd"
            name="dt"
            ngbDatepicker
            [placement]="'bottom-right'"
            #dd="ngbDatepicker"
          />

          <button type="button" class="datepicker-button" (click)="dd.toggle()">
            <i class="fas fa-calendar-alt"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer mt-3">
  <button class="button ml-auto w-134px">Add & Close</button>
</div>
